import Button from '@mui/material/Button';
// import { appInsights, reactPlugin } from '../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { gritComponentStyles } from '../gritComponents/gritComponentStyles';
import { saveAs } from 'file-saver';

import cn from 'clsx';
import LoadingButton from '@mui/lab/LoadingButton';

interface DebuggerPageProps {}

const Debugger = ({}: DebuggerPageProps) => {
  const [selectedXMLFiles, setSelectedXMLFiles] = useState<Array<File | null>>([]);
  const [debugEndpoint, setDebugEndpoint] = useState<string>('https://charlottetestapp.azurewebsites.net/api/LogApi');
  const [isDownloading, setisDownloading] = useState<boolean>(false);
  const url = 'https://charlottetestapp.azurewebsites.net/api/InsertDebugCalls';
  const classes = gritComponentStyles();
  const claimBlacklist: string[] = [];

  const handleXMLFileInput = (target: EventTarget & HTMLInputElement) => {
    console.log(target.files);
    if (target.files === null || target.files.length === 0) {
      setSelectedXMLFiles([]);
    } else {
      let files: Array<File | null> = [];
      for (let i = 0; i < target.files.length; i++) {
        files.push(target.files.item(i));
      }
      setSelectedXMLFiles(files);
    }

    target.value = '';
  };

  useEffect(() => {
    // console.log(selectedXMLFiles);
  }, [selectedXMLFiles]);

  const downloadPolicies = async () => {
    console.log('downloading policies with injected xml');
    setisDownloading(true);
    let xmlTextArrays: any[] = [];
    for (let i = 0; i < selectedXMLFiles.length; i++) {
      let text = await selectedXMLFiles[i]?.text();
      xmlTextArrays.push(text); // note things can be pushed outOfOrder but that dosent matter
    }

    let requestPayload = {
      buildId: '1.00',
      claimBlacklist: claimBlacklist,
      debugEndpoint: debugEndpoint,
      xml: xmlTextArrays,
    };
    let data = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestPayload),
    }).then((response) => {
      return response.json();
    });

    console.log(data);

    //create zip from JSON
    const zip = require('jszip')();
    for (let i = 0; i < data?.xml?.length; i++) {
      let text = data.xml[i];
      let file = new File([text], `${selectedXMLFiles[i]?.name}-Logged.xml`, {
        type: 'text/plain',
      });
      zip.file(`${selectedXMLFiles[i]?.name}-Logged.xml`, file);
    }

    // download the zip
    zip.generateAsync({ type: 'blob' }).then(function (blob: any) {
      saveAs(blob, 'DebuggerPolicies.zip');
    });

    setisDownloading(false);
  };

  const Input = styled('input')({
    display: 'none',
  });

  return (
    <>
      <div className={classes.flexRow}>
        <div className={classes.flexColfill}>
          <label htmlFor="policyUpload">
            <Input
              type="file"
              name="policyUpload"
              id="policyUpload"
              accept=".xml"
              multiple
              onChange={(e: { target: EventTarget & HTMLInputElement }) => handleXMLFileInput(e.target)}
            />
            <Button component="span">Upload Policy</Button>
          </label>

          <div className={classes.listFileContainer}>
            {selectedXMLFiles.map((file) => {
              return <li>{file?.name}</li>;
            })}
            {selectedXMLFiles.length < 1 && 'No Files Selected'}
          </div>
        </div>
        <div className={classes.flexColfill}>
          <LoadingButton
            loading={isDownloading}
            onClick={() => {
              downloadPolicies();
            }}
          >
            Download Injected Policies
          </LoadingButton>
        </div>
      </div>
    </>
  );
};

// export default withAITracking(reactPlugin, Debugger);
export default Debugger;
